import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  TemplateRef,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { FileService } from '@ipg/ngx-frontend-toolset';
import { ImageAction } from '../../../../../models/interactions.model';
import { AvatarComponent } from '../../../../avatar/avatar.component';

@Component({
  selector: 'app-image-action',
  imports: [AvatarComponent, MatIcon, CdkDragHandle, NgTemplateOutlet],
  templateUrl: './image-action.component.html',
  styleUrl: './image-action.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageActionComponent {
  private readonly _fileService = inject(FileService);

  public readonly data = input.required<ImageAction>();
  public readonly actions = input<TemplateRef<unknown>>();

  protected readonly imageUrl = computed(
    () => this._fileService.get(this.data().value.fileId).href,
  );
}
